module.exports = __webpack_public_path__ + "img/570.d4d653dc.jpg";